export const DEFAULT_TERRAIN_PROFILE_VIEW_STEP_SIZE = 0.5;
export const DEFAULT_TERRAIN_SECTION_VIEW_STEP_SIZE = 0.5;
export const DEFAULT_TRENCH_LABEL_COLOR = "#F283E5";
//# sourceMappingURL=defaults.js.map